// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2Bl2b","header":"PatientQuestionnaire_header__1aF6_","info":"PatientQuestionnaire_info__2e9K-"};